// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3afac8d0","389":"a6db7493","453":"7bba6932","455":"29fd73d2","857":"10e9eff8","977":"03902799"}[chunkId] + ".chunk.js";
};